// extracted by mini-css-extract-plugin
export default {"container":"offering-intro-module--container--3mVw1","description":"offering-intro-module--description--3MxAv"};